export { default as PieChart } from './PieChart'
export { default as Research } from './Research'
export { default as Rocket } from './Rocket'
export { default as SearchChart } from './SearchChart'
export { default as Suitcase } from './Suitcase'
export { default as Target } from './Target'
export { default as Teamwork } from './Teamwork'
